const _state = {
  loading: false,
  sitemap: sessionStorage.getItem('user-siteMap')
    ? JSON.parse(sessionStorage.getItem('user-siteMap'))
    : [],
  isNavOpen: true,
  isMobileDensity: false,
  showStudentInfo: false,
  selectedStudentId: null,
  isOpenSearchStudent: false,
  isLoggingOut: sessionStorage.getItem('isLoggingOut')
    ? JSON.parse(sessionStorage.getItem('isLoggingOut'))
    : false,
};

export const initialState = () => _state;

export const state = initialState();
